import { render } from "./SensorStatWeightSensor.vue?vue&type=template&id=0311840a"
import script from "./SensorStatWeightSensor.vue?vue&type=script&lang=js"
export * from "./SensorStatWeightSensor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__